module.exports = __webpack_public_path__ + "static/media/icon-checkmark.d060a734.svg";